export default __webpack_public_path__ + "b55678557e329b714221dff7123a43a7.svg";